module.exports = __webpack_public_path__ + "img/login.50e96e01.png";